export default class IsValidatedCommand {
    constructor(item) {
        this.id = item.id;
        this.isValidated = true;
        this.isCorrect = item.isCorrect;
    }
}